// // --------------image input

// import { userPlaceholder } from "assets/icons";
// import { useEffect, useState } from "react";

// export function ImageInput({ onFileSelect }) {
//   return (
//     <input
//       type="file"
//       accept="image/*"
//       onChange={(e) => onFileSelect(e.target.files[0])}
//     />
//   );
// }

// //   ------------image preview


// export function ImagePreview({ file, className = '' }) {
//   const [imageUrl, setImageUrl] = useState(null);


//   useEffect(() => {
//   if (!file) return;

//   if (typeof file === "string") {
//     const image =
//       file.startsWith("http")
//         ? file
//         : `https://sindhi-bucket.s3.ap-south-1.amazonaws.com/${file}`;

//     setImageUrl(image);
//   } else if (file instanceof File) {
//     const url = URL.createObjectURL(file);
//     setImageUrl(url);

//     return () => URL.revokeObjectURL(url);
//   }
// }, [file]);
// console.log(imageUrl,":::::::::::::::::::::")
//   return file && imageUrl && <img className={className} src={imageUrl || userPlaceholder} alt="Previewmmmmmmmmmmmmm" width={200} />;
// }

// // -------------------------Use Parent Component like this: connects everything







// --------------image input
import { useEffect, useState } from "react";

// Converts an <input type="file"> event's file(s) into blob preview URLs
export const ImageInput = (fileOrFileList) => {
  if (!fileOrFileList) return null;

  if (fileOrFileList instanceof FileList || Array.isArray(fileOrFileList)) {
    return Array.from(fileOrFileList).map((file) =>
      URL.createObjectURL(file),
    );
  }

  return URL.createObjectURL(fileOrFileList);
};

// Renders a preview image.
// Accepts either:
//  - a File/Blob object -> converts to a blob URL
//  - a string -> treated as an already-usable URL (blob:, http(s):, data:)
export const ImagePreview = ({ file, alt = "preview" }) => {
  const [src, setSrc] = useState("");

  useEffect(() => {
    if (!file) {
      setSrc("");
      return;
    }

    // Already a usable URL string (blob:, http, https, data:)
    if (typeof file === "string") {
      setSrc(file);
      return;
    }

    // File or Blob object
    if (file instanceof Blob) {
      const objectUrl = URL.createObjectURL(file);
      setSrc(objectUrl);

      // cleanup only for URLs we created here
      return () => URL.revokeObjectURL(objectUrl);
    }

    // Unknown type — don't set a broken src
    console.warn("ImagePreview: unsupported file type", file);
    setSrc("");
  }, [file]);

  if (!src) return null;

  return <img src={src} alt={alt} className="preview-img" />;
};